const initialState = {
  email: null,
  locale: null,
  date_notation: null,
  time_notation: null,
  avatar_url: null,
  calendar_accounts: null,
  cal_anonymous_id: null,
  diagnostics: {
    available: false,
    enabled: false
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CURRENT_USER':
      return {
        ...state,
        ...action.payload
      }

    case 'UPDATE_CAL_ANONYMOUS_ID':
      return {
        ...state,
        cal_anonymous_id: action.payload
      }

    case 'SET_DIAGNOSTICS_ENABLED':
      return {
        ...state,
        diagnostics: {
          ...state.diagnostics,
          enabled: action.payload.enabled
        }
      }

    default:
      return state
  }
}
